<script>
  import { onDestroy } from 'svelte';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let recObjectsStore = getGroupStore('recObjectsStore');

  import Track from '@utils/track';
  import { getCurrentUserStore } from '@stores/current_user';

  import GroupAjax from '@ajax/group';

  import CreateAccountModal from '@app-components/modal/CreateAccountModal.svelte';

  import tippy from 'tippy.js';

  export let recObjectId;
  export let style = '';
  export let viewStyle = 'list';
  export let allowToggling = true;
  export let mobile = false;
  export let displayCount = true;
  export let likes = {};
  export let customGroupStore;

  const SLOTS = $$props.$$slots || {};
  let currentUser = getCurrentUserStore('default');
  currentUser.subscribe((x) => (currentUser = x));

  let currentLikeId;
  let group = customGroupStore || groupStore;
  let recObject = recObjectsStore.find(recObjectId);
  let createAccountModal = false;

  let unsubRecObject = recObject.subscribe((x) => {
    if (x.likes != likes) {
      recObject = x;
      likes = recObject.likes || {};
    }
  });

  let setupTippy = function (node, likes) {
    let instance;

    let setup = function (likes) {
      let skippedUsers = 0;
      let users = likes.users;

      if (users) {
        var content = '';

        users.forEach((l) => {
          if (l.user) {
            content += l.user.name + '<br />';
          } else {
            skippedUsers += 1;
          }
        });

        if (skippedUsers > 0) {
          var otherLabel = skippedUsers == 1 ? 'other' : 'others';

          if (content == '') {
            content += `${skippedUsers} ${otherLabel}`;
          } else {
            content += `+ ${skippedUsers} ${otherLabel}`;
          }
        }

        if (content != '') {
          if (!instance) {
            instance = tippy(node, {
              allowHTML: true,
              content: content,
            });
          } else {
            instance.setContent(content);
          }
        } else if (instance) {
          instance.destroy();
          instance = undefined;
        }
      }
    };

    setup(likes);

    return {
      destroy() {
        if (instance) {
          instance.destroy();
        }
      },

      update(likes) {
        setup(likes);
      },
    };
  };

  export let toggleLike = async function () {
    if (!currentUser || !currentUser.id) {
      showCreateAccountModal();
      return;
    }

    let total = likes.total;

    if (likes.liked) {
      total -= 1;
    } else {
      total += 1;
    }

    recObject.set({
      ...recObject,
      likes: { ...likes, liked: !likes.liked, total },
    });

    let resp = await GroupAjax.like(group, {
      rec_object_id: recObject.id,
      current_like_id: currentLikeId,
    });

    currentLikeId = resp.id;
    recObject.set({ ...recObject, ...resp.rec_object });
  };

  let showCreateAccountModal = function () {
    createAccountModal = true;
  };

  let trackAccountCreated = function () {
    Track.likeAccountCreated({
      user: currentUser,
      recObject,
      group,
    });
  };

  onDestroy(() => {
    unsubRecObject();
  });
</script>

<style style="text/scss" lang="scss">
  .like {
    display: flex;
    align-items: center;
    cursor: pointer;

    span {
      margin-left: 8px;
      color: #000;
      font-weight: 500;
      font-size: 14px;
      margin-bottom: -1px;
    }
  }

  .mobile {
    span {
      font-size: 14px;
      margin-bottom: 0px !important;
      margin-left: 10px !important;
    }
  }

  .rec-object-like-btn {
    fill: #8e71ff;

    &:hover {
      fill: #896bd9;
    }
  }

  .detail-view {
    border: 2px solid #ececec;
    border-radius: 8px;
    cursor: pointer;
    padding: 8px;
    padding-left: 15px;
    padding-right: 15px;

    &:hover {
      background: #ececec;
      border: 2px solid #ececec;
    }
  }
</style>

{#if createAccountModal}
  <div>
    <CreateAccountModal
      mobile={mobile}
      eventDetails={{ trigger_event: 'like_button', group_base_id: group?.id, rec_object_id: recObject?.id }}
      successCallback={() => {
        createAccountModal = false;
        trackAccountCreated();
        toggleLike();
      }}
      showPassword={true}
      saveButtonFlow={true}
      bind:showModal={createAccountModal}
      beforeDataSend={(data) => {
        data['sign_up_source'] = {
          source: 'like',
          group_base_id: group && group.id,
          rec_object_id: recObject && recObject.id,
        };
        return data;
      }} />
  </div>
{/if}
<div
  class="like {viewStyle} {likes.liked ? 'liked' : ''}"
  style={style}
  class:mobile={mobile}
  on:click|preventDefault|stopPropagation={() => {
    if (allowToggling) {
      toggleLike();
    }
  }}>
  {#if SLOTS.img}
    <slot name="img" />
  {:else if likes.liked}
    <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 16 16" fill="none">
      <path
        d="M11.84 2C11.0163 2.00179 10.2116 2.2535 9.52801 2.72324C8.84439 3.19299 8.31259 3.85961 8 4.63863C7.68707 3.85875 7.15444 3.19154 6.46978 2.72173C5.78511 2.25192 4.97929 2.00071 4.15467 2C1.86133 2 0 4.33879 0 6.68847C0 11.824 6.93333 16 8 16C9.06667 16 16 11.824 16 6.68847C16 4.33879 14.1387 2 11.84 2Z"
        fill="#FF5567" />
    </svg>
  {:else}
    <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 20 18" fill="none" class="s-RLud9ny07R5l"
      ><path
        d="M14.08 2C13.2048 2.0019 12.3499 2.26934 11.6235 2.76845C10.8972 3.26755 10.3321 3.97584 10 4.80354C9.66751 3.97492 9.10159 3.26601 8.37414 2.76684C7.64668 2.26766 6.7905 2.00075 5.91433 2C3.47767 2 1.5 4.48496 1.5 6.9815C1.5 12.438 8.86667 16.875 10 16.875C11.1333 16.875 18.5 12.438 18.5 6.9815C18.5 4.48496 16.5223 2 14.08 2Z"
        stroke="#1a1a1a"
        stroke-width="1.5"
        class="s-RLud9ny07R5l"></path
      ></svg>
  {/if}

  {#if displayCount && likes.total > 0}
    <span
      use:setupTippy={likes}
      on:click={(e) => {
        if (mobile) {
          e.preventDefault();
          e.stopPropagation();
        }
      }}>
      {likes.total}
    </span>
  {/if}
</div>
